import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

import Button2 from '../Button2';
import styles from './Modal2.module.scss';

const ModalAction2 = ( props) => {
  const { primaryTitle, primaryAction, primaryDisabled, primaryTooltip, secondaryTitle, secondaryAction, secondaryDisabled, secondaryTooltip } = props;

  const displayPrimaryButton = useMemo(
    () => primaryTitle && (
      <Button2
        onClick={primaryAction}
        disabled={primaryDisabled}
        tooltip={primaryTooltip}
      >
        {primaryTitle}
      </Button2>
    ),
    [primaryTitle, primaryAction, primaryDisabled, primaryTooltip]
  );

  const displaySecondaryButton = useMemo(
    () => secondaryTitle && (
      <Button2
        theme="tertiary"
        size="big"
        onClick={secondaryAction}
        disabled={secondaryDisabled}
        tooltip={secondaryTooltip}
      >
        {secondaryTitle}
      </Button2>
    ),
    [secondaryTitle, secondaryAction, secondaryDisabled, secondaryTooltip]
  );

  return (
    <div className={styles.modalAction} {...props}>
      {displaySecondaryButton}
      {displayPrimaryButton}
    </div>
  )
};

ModalAction2.propTypes = {
  primaryTitle: PropTypes.string,
  secondaryTitle: PropTypes.string,
  primaryAction: PropTypes.func,
  primaryTooltip: PropTypes.string,
  secondaryAction: PropTypes.func,
  primaryDisabled: PropTypes.bool,
  secondaryDisabled: PropTypes.bool,
  secondaryTooltip: PropTypes.string
}

ModalAction2.defaultProps = {
  primaryTitle: null,
  secondaryTitle: null,
  primaryAction: null,
  primaryTooltip: null,
  secondaryAction: null,
  primaryDisabled: false,
  secondaryDisabled: false,
  secondaryTooltip: null
}

export default memo(ModalAction2);
